import { Pipe, PipeTransform } from '@angular/core'
import * as moment from 'moment'

@Pipe({
  name: 'datetimeToDate'
})
// The work of the pipe is handled in the tranform method with our pipe's class
export class DatetimeToDate implements PipeTransform {
  transform(value: string, args: any[]) {
    var time = value.split('T')[1]
    return time.substring(0, 2) + 'h' + time.substring(2, 4)
  }
}

@Pipe({
  name: 'datetime'
})
// The work of the pipe is handled in the tranform method with our pipe's class
export class Datetime implements PipeTransform {
  transform(value: string, args: any[]) {
    //let now = moment('20160112T1232', 'YYYYMMDDTHHmm')
    let now = moment()
    let minutes = moment(value, 'YYYYMMDDTHHmm').diff(now, 'minutes')
    return minutes > 59 ? '> ' + Math.floor(minutes / 60) : minutes
  }
}

@Pipe({
  name: 'minutes'
})
// The work of the pipe is handled in the tranform method with our pipe's class
export class Minutes implements PipeTransform {
  transform(value: string, args: any[]) {
    //let now = moment('20160112T1232', 'YYYYMMDDTHHmm')
    let now = moment()
    let minutes = moment(value, 'YYYYMMDDTHHmm').diff(now, 'minutes')
    return minutes
  }
}
